module.exports = __webpack_public_path__ + "static/img/share-wx.37ce5e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/qml/img/share-wx.png
// module id = 65YL
// module chunks = 1